import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LostpasswordComponent } from './lostpassword/lostpassword.component'
import { FirstLoginComponent } from './first-login/first-login.component';
import { AuthGuard } from '../_guard/auth.guard';
import { IsConnectedComponent } from './is-connected/is-connected.component';
import { IsDeconnectdComponent } from './is-deconnectd/is-deconnectd.component';

const routes: Routes = [
  {
    path:'login',
    component: LoginComponent
  },
  {
    path:'lostpassword',
    component:LostpasswordComponent
  },
  {
    path:'first-login',
    component:FirstLoginComponent
  },
  {
    path: 'sso/connected',
    component:IsConnectedComponent
  },

  {
    path: 'sso/deconnected',
    component:IsDeconnectdComponent
  },
  {
    path:'chat',
    loadChildren:() =>import('./chat/home.module').then(mod => mod.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path:'cr',
    loadChildren:() =>import('./cr/cr.module').then(mod => mod.CrModule),
    canActivate: [AuthGuard]
  },
  {
    path:'analytics',
    loadChildren:() =>import('./analytics/analytics.module').then(mod => mod.AnalyticsModule),
    canActivate: [AuthGuard]
  },
  {
    path:'shared',
    loadChildren:() =>import('./shared-items/shared-items.module').then(mod => mod.SharedItemsModule),
    canActivate: [AuthGuard]
  },
  {
    path:'trash',
    loadChildren:() =>import('../app/trash/trash.module').then(mod => mod.TrashModule),
    canActivate: [AuthGuard]
  },
  {
    path:'user',
    loadChildren:() =>import('../app/user/user.module').then(mod => mod.UserModule),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: 'login' },
  { path: '', redirectTo: 'login', pathMatch: 'full' },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
